import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/ewenyau/repo/gateway_manual/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Printbreak } from './printbreak';
import { DenseTable } from './specification';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "gateway-manual"
    }}>{`Gateway Manual`}</h1>
    <p><img alt="Gateway" src={require("./gw.jpg")} /></p>
    <h2 {...{
      "id": "installing-the-device"
    }}>{`Installing the Device`}</h2>
    <p>{`Use POE RJ45 cable to connect with the Gateway`}</p>
    <h2 {...{
      "id": "dhcp"
    }}>{`DHCP`}</h2>
    <p>{`DHCP client is enabled by default. If no DHCP server in the local network, the gatway falls back to IP of 192.168.1.23/24.`}</p>
    <h2 {...{
      "id": "login-in-gui"
    }}>{`Login in GUI`}</h2>
    <p>{`Go to the GUI of the Gateway`}</p>
    <p>{`The GUI hosts on 80 port`}</p>
    <p>{`  `}<inlineCode parentName="p">{`https://thegatewayip`}</inlineCode></p>

    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "login-page"
    }}>{`Login Page`}</h2>
    <p><img alt="LoginPage" src={require("./login.png")} /></p>
    <p>{`Login With:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Username: admin`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Password: admin`}</p>
      </li>
    </ul>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "update-radio-setting-in-gui"
    }}>{`Update Radio Setting in GUI`}</h2>
    <p><img alt="Packet Forwarder" src={require("./forwarder.png")} /></p>
    <p>{`Packet Forwarder Setting :`}</p>
    <ul>
      <li parentName="ul">{`Setting Server Address as Destination Address `}</li>
      <li parentName="ul">{`Setting Server Port`}</li>
      <li parentName="ul">{`The Gateway will forward the data to the server address with specify port.`}</li>
    </ul>
    <Printbreak mdxType="Printbreak" />
    <p>{`Input the IP address of the server which need to handle LoRa data`}</p>
    <p>{`For example:`}</p>
    <p><img alt="Server Address" src={require("./serveradd.png")} /></p>
    <p>{`Input the port number of the server to commumicate`}</p>
    <p>{`For example:`}</p>
    <p><img alt="Server Port" src={require("./serverport.png")} /></p>
    <p>{`The gateway has 8 channels. The Radio 0 and 1 is the central frequency. The frequency of each channels needs to specify positive and negative adjustment depending on the frequency of the radio.`}</p>
    <p>{`After Setting channels,press 'Save' button to apply.`}</p>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "lora-outdoor-gateway-specification"
    }}>{`LoRa Outdoor Gateway Specification`}</h2>

    <DenseTable mdxType="DenseTable" />
    <Printbreak mdxType="Printbreak" />
    <p><img alt="Gateway_white" src={require("./detailgateway_font_white.png")} /></p>
    <Printbreak mdxType="Printbreak" />
    <p><img alt="Gateway_white" src={require("./detailgateway_font.png")} /></p>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "regulatory-information"
    }}>{`Regulatory Information`}</h2>
    <h3 {...{
      "id": "emc-safety-and-rtte-directive-red-compliance"
    }}>{`EMC, Safety, and R&TTE Directive (RED) Compliance`}</h3>
    <p>{`The CE mark is affixed to this product to confirm compliance with the following European Community Directives:`}</p>
    <pre><code parentName="pre" {...{}}>{`Council Directive 2011/65/EU on the restriction of the use of certain hazardous substances in electrical
and electronic equipment;

and

Council Directive 2014/53/EU on radio equipment and telecommunications terminal equipment and the
mutual recognition of their conformity.

and

Council Directive 2014/35/EU on the harmonization of the laws of Member States relating to Electrical
Equipment designed for use within certain voltage limits.
`}</code></pre>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "installation-safety"
    }}>{`Installation Safety`}</h2>
    <p>{`This information is also available in the Installation Guide.`}</p>
    <p>{`  Warnings and Cautions
Warning and Caution symbols mean potential danger. You are in a situation that could cause bodily injury. Before
working on any equipment, be aware of hazards in the installation area and be knowledgeable about electrical
circuitry. Be familiar with standard practices for preventing accidents.`}</p>
    <p>{`  For translations of key cautions and warnings, refer Appendix A.`}</p>
    <p>{`Warning: Only trained and qualified personnel should install, replace, or service this equipment. Installation
must comply with local and national electrical codes.`}</p>
    <pre><code parentName="pre" {...{}}>{`  When installing or replacing the unit, the ground connection must always be made first and disconnected last.

   - Disconnect POE power (Ethernet POE port) before servicing IP67 Base Station.

   - Do not work on the system or connect or disconnect cables during periods of lightning activity.

   - This device is not designed or approved to be used in any Hazardous Locations. 
     Do not install or operate device if area is known to be an explosive environment.

   - Externally ground this equipment using a customer-supplied ground wire before applying power.

   - Contact an electrician if you are uncertain that suitable grounding is available. 
     Refer to Installing the Ground Wire instructions. 
     < All wall mounting installations are subject to the acceptance of local jurisdiction.

   - Do not locate antenna near overhead power lines or other electric light or power circuits, 
     or where it can come into contact with such circuits. 
     When installing the antenna, take extreme care not to come into contact with such circuits, 
     because they may cause serious injury or death. 
     For proper installation and grounding of the antenna, 
     please refer to national and local codes.
`}</code></pre>
    <p>{`Warning:`}</p>
    <p>{`  HOT SURFACE DO NOT TOUCH`}</p>
    <p>{`  Note: This symbol is included on the serial label. UL evaluated this device to a safety and outdoor certification temperature of -30c to +70c.`}</p>
    <h3 {...{
      "id": "lithium-battery"
    }}>{`Lithium Battery`}</h3>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`A lithium battery (3V, coin cell, CR1632) located within the product provides backup power for the timekeeping. This battery has an estimated life expectancy of ten years.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`When this battery starts to weaken, the date and time may be incorrect.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Battery is not user replaceable. If the battery fails, the device must be sent back to Invisible fun studio ltd Systems for battery replacement.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Lithium cells and batteries are subject to the Provisions for International Transportation. Invisible fun studio ltd confirms that the Lithium batteries used in the Invisible fun studio ltd product(s) referenced in this manual comply with Special Provision 188 of the UN Model Regulations, Special Provision A45 of the ICAO-TI/IATADGR (Air),  Special Provision 310 of the IMDG Code, and Special Provision 188 of the ADR and RID (Road and Rail Europe).`}</p>
        <p parentName="li">{`CAUTION: Risk of explosion if this battery is replaced by an incorrect type. Dispose of batteries according to
instructions.`}</p>
        <p parentName="li">{`Attention: Risque d'explosion si vous remplacez la batterie par un modèle incompatible. Jetez les piles usagées
selon les instructions.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "user-responsibility"
    }}>{`User Responsibility`}</h2>
    <p>{`  Respect all local regulations for operating your wireless device. Use the security features to block unauthorized use and theft.`}</p>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "device-maintenance"
    }}>{`Device Maintenance`}</h2>
    <p>{`  Do not attempt to disassemble the device. There are no user serviceable parts inside.
When maintaining your device:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Do not misuse the device. Follow instructions on proper operation and only use as intended. Misuse could make the device inoperable, damage the device and/or other equipment, or harm users`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Do not apply excessive pressure or place unnecessary weight on the device. This could result in damage to the device or harm to users.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Do not use this device in explosive or hazardous environments unless the model is specifically approved for such use. The device may cause sparks. Sparks in explosive areas could cause explosion or fire and may result in property damage, severe injury, and/or death.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Do not expose your device to any extreme environment where the temperature or humidity is high. Such exposure could result in damage to the device or fire. Refer to the device specifications regarding recommended operating temperature and humidity.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Do not place the device alongside computer discs, credit or travel cards, or other magnetic media. The information contained on discs or cards may be affected by the device.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Using accessories, such as antennas, that Invisible fun studio ltd has not authorized or that are not compliant with Invisible fun studio ltd's accessory specifications may invalidate the warranty.`}</p>
      </li>
    </ul>
    <p>{`Notice regarding Compliance with FCC, EU, and Industry Canada Requirements for RF Exposure`}</p>
    <p>{`  The antenna intended for use with this unit meets the requirements for mobile operating configurations and for
fixed mounted operations, as defined in 2.1091 of the FCC rules for satisfying RF exposure compliance. This device
also meets the European RF exposure requirements of EN 62311. If an alternate antenna is used, consult user
documentation for required antenna specifications.`}</p>
    <p>{`  Compliance of the device with the FCC, EU and IC rules regarding RF Exposure was established and is given with
the maximum antenna gain as specified above for a minimum distance of 35 cm between the devices radiating
structures (the antenna) and the body of users. Qualification for distances closer than 35 cm (portable operation)
would require re-certification.`}</p>
    <p>{`  Wireless devices could generate radiation. Other nearby electronic devices, like microwave ovens, may also
generate additional radiation to the user causing a higher level of RF exposure.`}</p>
    <h2 {...{
      "id": "radio-frequency-rf-safety"
    }}>{`Radio Frequency (RF) Safety`}</h2>
    <p>{`Due to the possibility of radio frequency (RF) interference, it is important that you follow any special regulations
regarding the use of radio equipment. Follow the safety advice given below.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Operating your device close to other electronic equipment may cause interference if the equipment is inadequately protected. Observe any warning signs and manufacturers’ recommendations.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Different industries and businesses restrict the use of cellular devices. Respect restrictions on the use of radio equipment in fuel depots, chemical plants, or where blasting operations are in process. Follow restrictions for any environment where you operate the device.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Do not place the antenna outdoors.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Switch OFF your wireless device when in an aircraft. Using portable electronic devices in an aircraft may endanger aircraft operation, disrupt the cellular network, and is illegal. Failing to observe this restriction may lead to suspension or denial of cellular services to the offender, legal action, or both.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Switch OFF your wireless device when around gasoline or diesel-fuel pumps and before filling your vehiclewith fuel.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Switch OFF your wireless device in hospitals and any other place where medical equipment may be in use.`}</p>
      </li>
    </ul>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "interference-with-pacemakers-and-other-medical-devices"
    }}>{`Interference with Pacemakers and Other Medical Devices`}</h2>
    <p>{` Potential interference`}</p>
    <p>{`  Radio frequency energy (RF) from cellular devices can interact with some electronic devices. This is
electromagnetic interference (EMI). The FDA helped develop a detailed test method to measure EMI of implanted
cardiac pacemakers and defibrillators from cellular devices. This test method is part of the Association for the
Advancement of Medical Instrumentation (AAMI) standard. This standard allows manufacturers to ensure that
cardiac pacemakers and defibrillators are safe from cellular device EMI.`}</p>
    <p>{`  The FDA continues to monitor cellular devices for interactions with other medical devices. If harmful interference
occurs, the FDA will assess the interference and work to resolve the problem.`}</p>
    <h2 {...{
      "id": "precautions-for-pacemaker-wearers"
    }}>{`Precautions for pacemaker wearers`}</h2>
    <p>{`If EMI occurs, it could affect a pacemaker in one of three ways:`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Stop the pacemaker from delivering the stimulating pulses that regulate the heart's rhythm.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Cause the pacemaker to deliver the pulses irregularly.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Cause the pacemaker to ignore the heart's own rhythm and deliver pulses at a fixed rate.`}</p>
      </li>
    </ul>
    <p>{`Based on current research, cellular devices do not pose a significant health problem for most pacemaker wearers.
However, people with pacemakers may want to take simple precautions to be sure that their device doesn't cause
a problem.`}</p>
    <p>{`  Keep the device on the opposite side of the body from the pacemaker to add extra distance between the
pacemaker and the device.`}</p>
    <p>{`  Avoid placing a turned-on device next to the pacemaker (for example, don’t carry the device in a shirt or
jacket pocket directly over the pacemaker).`}</p>
    <Printbreak mdxType="Printbreak" />
    <h2 {...{
      "id": "waste-electrical-and-electronic-equipment-statement"
    }}>{`Waste Electrical and Electronic Equipment Statement`}</h2>
    <p>{`  Note: This statement may be used in documentation for your final product applications.`}</p>
    <h3 {...{
      "id": "weee-directive"
    }}>{`WEEE Directive`}</h3>
    <p>{`  The WEEE Directive places an obligation on EU-based manufacturers, distributors, retailers, and importers to takeback electronics products at the end of their useful life. A sister directive, ROHS (Restriction of Hazardous
Substances) complements the WEEE Directive by banning the presence of specific hazardous substances in the
products at the design phase. The WEEE Directive covers all Invisible fun studio ltd products imported into the EU as of August
13, 2005. EU-based manufacturers, distributors, retailers and importers are obliged to finance the costs of recovery
from municipal collection points, reuse, and recycling of specified percentages per the WEEE requirements.`}</p>
    <h3 {...{
      "id": "instructions-for-disposal-of-weee-by-users-in-the-european-union"
    }}>{`Instructions for Disposal of WEEE by Users in the European Union`}</h3>
    <p>{`  The symbol shown below is on the product or on its packaging, which indicates that this product must not be
disposed of with other waste. Instead, it is the user's responsibility to dispose of their waste equipment by handing
it over to a designated collection point for the recycling of waste electrical and electronic equipment. The separate
collection and recycling of your waste equipment at the time of disposal will help to conserve natural resources
and ensure that it is recycled in a manner that protects human health and the environment. For more information
about where you can drop off your waste equipment for recycling, please contact your local city office, your
household waste disposal service or where you purchased the product.`}</p>
    <h2 {...{
      "id": "restriction-of-the-use-of-hazardous-substances-rohs"
    }}>{`Restriction of the Use of Hazardous Substances (RoHS)`}</h2>
    <p>{`Invisible fun studio ltd`}</p>
    <p>{`Certificate of Compliance`}</p>
    <p>{`2015/863`}</p>
    <p>{`Invisible fun studio ltd confirms that its embedded products comply with the chemical concentration limitations
set forth in the directive 2015/863 of the European Parliament (Restriction of the use of certain Hazardous
Substances in electrical and electronic equipment - RoHS).`}</p>
    <Printbreak mdxType="Printbreak" />
    <p>{`These Invisible fun studio ltd products do not contain the following banned chemicals:`}</p>
    <ul>
      <li parentName="ul">{`Lead, `}{`[Pb]`}{` < 1000 PPM`}</li>
      <li parentName="ul">{`Mercury, `}{`[Hg]`}{` < 100 PPM`}</li>
      <li parentName="ul">{`Cadmium, `}{`[Cd]`}{` < 100 PPM`}</li>
      <li parentName="ul">{`Hexavalent Chromium, `}{`[Cr+6]`}{` < 1000 PPM`}</li>
      <li parentName="ul">{`Polybrominated Biphenyl, `}{`[PBB]`}{` < 1000 PPM`}</li>
      <li parentName="ul">{`ENVIRONMENTAL NOTICES`}</li>
      <li parentName="ul">{`34 Conduit® Base Station IP67 Getting Started Guide for Versions 1.5 and 2.1`}</li>
      <li parentName="ul">{`Polybrominated Diphenyl Ethers, `}{`[PBDE]`}{` < 1000 PPM`}</li>
      <li parentName="ul">{`Bis(2-Ethylhexyl) phthalate (DEHP): < 1000 ppm`}</li>
      <li parentName="ul">{`Benzyl butyl phthalate (BBP): < 1000 ppm`}</li>
      <li parentName="ul">{`Dibutyl phthalate (DBP): < 1000 ppm`}</li>
      <li parentName="ul">{`Diisobutyl phthalate (DIBP): < 1000 ppm`}</li>
      <li parentName="ul">{`Environmental considerations:`}</li>
      <li parentName="ul">{`Moisture Sensitivity Level (MSL) =1`}</li>
      <li parentName="ul">{`Maximum Soldering temperature = 260C (in SMT reflow oven)`}</li>
    </ul>
    <p>{`Lead usage in some components is exempted by the following RoHS annex, therefore higher lead concentration
would be found in some modules (>1000 PPM);`}</p>
    <p>{`Resistors containing lead in a glass or ceramic matrix compound.`}</p>
    <h2 {...{
      "id": "reach-statement"
    }}>{`REACH Statement`}</h2>
    <p>{`Registration of Substances`}</p>
    <p>{`Invisible fun studio ltd confirms that none of its products or packaging contain any of the Substances of Very
High Concern (SVHC) on the REACH Candidate List, in a concentration above the 0.1% by weight allowable limit`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      